import type { IntensityKind, NumericFieldKind } from "@jackedlogs/shared";

// Shared by ComposerSetTable and the two row components it splits into
// (ComposerMemberHead, ComposerSetRow). These live here rather than in the
// table because the table IMPORTS both children: exporting them from there and
// importing back would be a cycle, and re-typing them in each file is how the
// five icon-buttons below silently stop matching.

// Adjacent icon-buttons: box 36 + this hitSlop = a 44×48 touch that meets its
// neighbour exactly at the gap boundary with no overlap, the ≥44 floor without
// a wider visual box (PRODUCT.md: compact control, reach via hitSlop). Left/
// right 4 fills the row's 8px column gap; top/bottom 6 fits the card's 6px row
// gap (8 would push a 2px vertical overlap onto the row below). One const so
// the five buttons stay identical — three in ComposerMemberHead, two in
// ComposerSetRow.
export const ICON_HIT = { top: 6, bottom: 6, left: 4, right: 4 } as const;

// Map the intensity kind to the numeric-validation field. Percent rides the
// "weight" rule (non-negative number); its 0..200 range stays a save-time
// check (buildIntensity), same as before.
export const valueFieldKind = (kind: IntensityKind): NumericFieldKind =>
  kind === "rpe" ? "rpe" : kind === "rir" ? "rir" : "weight";
